// extracted by mini-css-extract-plugin
module.exports = {"container":"ChannelUserLimit_container__OqKN4","heading":"ChannelUserLimit_heading__1S1SI","limitInput":"ChannelUserLimit_limitInput__1dS_r"};